export const CourseTypes = {
  COURSE_TYPE_COURSE: 1,
  COURSE_TYPE_EDUCATION: 2,
  COURSE_TYPE_SAP: 3,
  COURSE_TYPE_RETRAINING: 4,
  COURSE_TYPE_AVGS: 5,
  COURSE_TYPE_TRAINING: 10,
};
export const engagementTypes = {
  ENGAGEMENT_TYPE_FULL_TIME: 'full_time',
  ENGAGEMENT_TYPE_PART_TIME: 'part_time',
};

export const CourseTypesList = [
  { id: CourseTypes.COURSE_TYPE_COURSE, name: 'Course' },
  { id: CourseTypes.COURSE_TYPE_EDUCATION, name: 'Education' },
  { id: CourseTypes.COURSE_TYPE_SAP, name: 'Hauszertifikat' },
  { id: CourseTypes.COURSE_TYPE_RETRAINING, name: 'Retraining' },
  { id: CourseTypes.COURSE_TYPE_AVGS, name: 'Avgs' },
  { id: CourseTypes.COURSE_TYPE_TRAINING, name: 'Training' },
];


export const EngagementTypesList = [
  { id: engagementTypes.ENGAGEMENT_TYPE_FULL_TIME, name: 'Full time' },
  { id: engagementTypes.ENGAGEMENT_TYPE_PART_TIME, name: 'Part time' },
];
